<template>
    <div>
        <table border="1" width="100%">
            <thead>
            <tr>
                <th align="center" style="background: #a1ccef;text-align: center" colspan="6">

                    <el-row :gutter="20" style="margin: 20px 0px 20px 0px">
                        <el-col :span="20">
                            Plurianual
                        </el-col>
                        <el-row>
                            <el-col :span="1">
                                <el-tooltip class="item" effect="dark" content="Agregar Año" placement="top">
                                    <el-button align="right" :disabled="!providerActive2"
                                               icon="fas fa-plus"
                                               size="small"

                                               @click="addYearMulti(requestForm.provider_selected)">
                                    </el-button>
                                </el-tooltip>

                            </el-col>
                            <el-col :span="1">
                                <el-tooltip class="item" effect="dark" content="Quitar Año" placement="top">
                                    <el-button align="right" :disabled="!providerActive2" type="danger"
                                               icon="fas fa-times-circle"
                                               size="small"
                                               @click="removeYearMulti(requestForm.provider_selected)">
                                    </el-button>
                                </el-tooltip>

                            </el-col>
                        </el-row>

                    </el-row>
                </th>
            </tr>

            <tr>
                <th align="center" style="background: #a1ccef;text-align: center" rowspan="2">
                    Años
                </th>
                <th align="center" style="background: #a1ccef;text-align: center" colspan="5">
                    Moneda
                </th>
            </tr>

            <tr>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Mensual
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Meses
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Total
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Otros gastos
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Gran Total
                </th>
            </tr>

            </thead>
            <tr v-for="(item, key) in filter(requestForm.provider_selected.cat_agreement_multiyear_id, requestForm.provider_selected.payments_multiyears)"
                :key="key+'_mu'">
                <td>{{ item.year }}</td>
                <td align="center">
                    <el-form-item
                            label="">
                        <el-input-number v-model="item.monthly"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>

                    </el-form-item>
                </td>

                <td align="center">
                    <el-form-item
                            label="">
                        <el-input-number v-model="item.months"
                                         :precision="0"
                                         :step="1"
                                         :min="0"
                                         :max="12"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>

                    </el-form-item>
                </td>

                <td align="center">

                    {{ (parseFloat(item.monthly) * parseFloat(item.months)) | currency('$') }}
                </td>

                <td align="center">
                    <el-form-item
                            label="">
                        <el-input-number v-model="item.otherExpenses"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>

                    </el-form-item>
                </td>

                <td align="center">
                    {{ ((parseFloat(item.monthly) * parseFloat(item.months))+ parseFloat(item.otherExpenses)) |
                    currency('$') }}
                </td>

            </tr>

            <tr>
                <td style="font-weight: bold;background: #c9c9c9c9">
					<span>
						Total
					</span>
                </td>
                <td align="center" style="font-weight: bold;background: #c9c9c9c9">
                    <!--{{// total(requestForm.provider_selected.payments_multiyears,1) | currency('$')}}-->
                </td>
                <td align="center" style="font-weight: bold;background: #c9c9c9c9">
                    {{total(requestForm.provider_selected.payments_multiyears,2)}}
                </td>
                <td align="center" style="font-weight: bold;background: #c9c9c9c9">
                    {{total(requestForm.provider_selected.payments_multiyears,3) | currency('$')}}
                </td>
                <td align="center" style="font-weight: bold;background: #c9c9c9c9">
                    {{total(requestForm.provider_selected.payments_multiyears,4) | currency('$')}}
                </td>
                <td align="center" style="font-weight: bold;background: #c9c9c9c9">
                    {{total(requestForm.provider_selected.payments_multiyears,5) | currency('$')}}
                </td>
            </tr>
        </table>
        <br/>


        <table border="1" width="100%">
            <thead>
            <tr>
                <th align="center" style="background: #a1ccef;text-align: center" colspan="6">

                    <el-row :gutter="20" style="margin: 20px 0px 20px 0px">
                        <el-col :span="20">
                            Contratos anuales por el mismo periodo
                        </el-col>
                        <el-row>
                            <el-col :span="1">
                                <el-tooltip class="item" effect="dark" content="Agregar Año" placement="top">
                                    <el-button align="right" :disabled="!providerActive2"
                                               icon="fas fa-plus"
                                               size="small"
                                               @click="addYearAnnual(requestForm.provider_selected)">
                                    </el-button>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="1">
                                <el-tooltip class="item" effect="dark" content="Quitar Año" placement="top">
                                    <el-button align="right" :disabled="!providerActive2" type="danger"
                                               icon="fas fa-times-circle"
                                               size="small"
                                               @click="removeYearAnnual(requestForm.provider_selected)">
                                    </el-button>
                                </el-tooltip>

                            </el-col>
                        </el-row>

                    </el-row>

                </th>
            </tr>

            <tr>
                <th align="center" style="background: #a1ccef;text-align: center" rowspan="2">
                    Años
                </th>
                <th align="center" style="background: #a1ccef;text-align: center" colspan="5">
                    Moneda
                </th>
            </tr>

            <tr>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Mensual
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Meses
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Total
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Otros gastos
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Gran Total
                </th>
            </tr>

            </thead>
            <tr v-for="(item, key) in filter(requestForm.provider_selected.cat_agreement_multiyear_id, requestForm.provider_selected.payments_annuals)"
                :key="key+'_mu'">
                <td>{{ item.year }}</td>
                <td align="center">
                    <el-form-item
                            label="">
                        <el-input-number v-model="item.monthly"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>

                    </el-form-item>
                </td>

                <td align="center">
                    <el-form-item
                            label="">
                        <el-input-number v-model="item.months"
                                         :precision="0"
                                         :step="1"
                                         :min="0"
                                         :max="12"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>

                    </el-form-item>
                </td>

                <td align="center">

                    {{ (parseFloat(item.monthly) * parseFloat(item.months)) | currency('$') }}
                </td>

                <td align="center">
                    <el-form-item
                            label="">
                        <el-input-number v-model="item.otherExpenses"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>

                    </el-form-item>
                </td>

                <td align="center">
                    {{ ((parseFloat(item.monthly) * parseFloat(item.months)) + parseFloat(item.otherExpenses)) |
                    currency('$') }}
                </td>

            </tr>
            <tr>
                <td style="font-weight: bold;background: #c9c9c9c9">
					<span>
						Total
					</span>
                </td>
                <td align="center" style="font-weight: bold;background: #c9c9c9c9">
                    <!--{{// total(requestForm.provider_selected.payments_annuals,1) | currency('$')}}-->
                </td>
                <td align="center" style="font-weight: bold;background: #c9c9c9c9">
                    {{total(requestForm.provider_selected.payments_annuals,2)}}
                </td>
                <td align="center" style="font-weight: bold;background: #c9c9c9c9">
                    {{total(requestForm.provider_selected.payments_annuals,3) | currency('$')}}
                </td>
                <td align="center" style="font-weight: bold;background: #c9c9c9c9">
                    {{total(requestForm.provider_selected.payments_annuals,4) | currency('$')}}
                </td>
                <td align="center" style="font-weight: bold;background: #c9c9c9c9">
                    {{total(requestForm.provider_selected.payments_annuals,5) | currency('$')}}
                </td>
            </tr>
            <tr>
                <th colspan="3" align="center" style="font-weight: bold;background: #a1ccef">
                    <div align="center">
                        Ahorros
                    </div>

                </th>

                <td align="center" style="font-weight: bold;background: #a1ccef">

                    {{absoluteValue(total(requestForm.provider_selected.payments_annuals,3) ,
                    total(requestForm.provider_selected.payments_multiyears,3)) | currency('$')}}

                </td>

                <td colspan="2" style="font-weight: bold;background: #a1ccef">
                    <div align="right" style="padding-right: 70px;">
                        {{absoluteValue(total(requestForm.provider_selected.payments_annuals,5) ,
                        total(requestForm.provider_selected.payments_multiyears,5)) | currency('$')}}

                    </div>
                </td>
            </tr>
        </table>

    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from "vuex"

    export default {
        props: {
            providerActive: {
                required: true
            }
        },
        computed: {
            ...mapGetters("form", {
                requestForm: "requestForm",
                catalogs: "catalogs",
                general: "general",
                onlyRead: "onlyRead",
                providerActive2: "providerActive",
            }),
        },
        methods: {

            ...mapMutations('form', {
                addYearMulti: "addYearMulti",
                addYearAnnual: "addYearAnnual",
                removeYearMulti: "removeYearMulti",
                removeYearAnnual: "removeYearAnnual"
            }),
            filter(cat_agreement_multiyear_id, array) {
                if (!array) return [];

                if (cat_agreement_multiyear_id == 2) {
                    return array.filter(item => item.year == 2019)
                }
                return array;
            },

            total(item, type) {
                let total = 0;
                if (type == 1) {
                    item.forEach(item => {
                        let _aux = parseFloat(item.monthly);
                        total = total + _aux;
                    });
                } else if (type == 2) {
                    item.forEach(item => {
                        let _aux = parseFloat(item.months);
                        total = total + _aux;
                    });
                } else if (type == 3) {
                    item.forEach(item => {
                        let _aux = parseFloat(item.monthly);
                        let _aux2 = parseFloat(item.months);
                        total = total + (_aux * _aux2);
                    });
                } else if (type == 4) {
                    item.forEach(item => {
                        let _aux = parseFloat(item.otherExpenses);
                        total = total + _aux;
                    });
                } else if (type == 5) {
                    item.forEach(item => {
                        let _aux = parseFloat(item.monthly);
                        let _aux2 = parseFloat(item.months);
                        let _aux3 = parseFloat(item.otherExpenses);
                        total = total + (_aux * _aux2) + _aux3;
                    });
                }
                return total;

            },

            absoluteValue(operator1, operator2) {

                let substrac = operator1 - operator2;

                if (substrac < 0) {
                    substrac = substrac * -1;
                }
                return substrac
            },

        }
    }
</script>

<style scoped>

</style>